import { ChatGptResponse } from './PromptGeneratorApiClient.types';
import { IPromptGeneratorApiClient } from './PromptGeneratorApiService.types';
import Strings from '../../common/Strings';

export default class PromptGeneratorApiService {
    promptGeneratorApiClient: IPromptGeneratorApiClient;

  constructor(promptGeneratorApiClient: IPromptGeneratorApiClient) {
    this.promptGeneratorApiClient = promptGeneratorApiClient;
  }

  /**
   * Get an enhanced prompt using the selected AI model
   * 
   * @param prompt - The user's input to enhance
   * @param isChatGpt4 - Legacy parameter (deprecated, use modelId instead)
   * @param modelId - Optional: Model ID for multi-model support
   */
  async getEnhancedPrompt(
    prompt: string,
    isChatGpt4: boolean,
    modelId?: string,
    volume?: string,
    issueType?: string
  ) {
    try {
      const generatedPrompt = (await this.promptGeneratorApiClient.generateEnhancedPrompt(
        prompt,
        isChatGpt4,
        modelId,
        volume as never,
        issueType as never
      )) as ChatGptResponse;
      return generatedPrompt.choices[0].message.content;
    } catch (err) {
      throw new Error(Strings.ERROR_MESSAGES.ENHANCE_AI_PROMPT_FAIL);
    }
  }
}
